import {
    RIMACOMI_ACCEPT_CALLBACK_URLS,
    RIMACOMI_CONFIRM_COMPONENT,
    RIMACOMI_DEFAULT_CALLBACK_URL,
    RIMACOMI_EMAIL_DOMAINS,
    RIMACOMI_LINKAGE_ID,
    RIMACOMI_LINKAGE_NAME,
    RIMACOMI_PATH, RIMACOMI_PROFILE_COMPLETE_CUSTOM_COMPONENT,
    RIMACOMI_PROFILE_COMPONENT,
    RIMACOMI_SERVICE_TERM_URL,
    RIMACOMI_SITE_UNIQ_API_PATH,
    RIMACOMI_WITHDRAW_CUSTOM_COMPONENT
} from "@/commons/linkage/sites/rimacomi";
import { createLinkageRoute, linkageBeforeEach, linkageScrollBehavior } from "@/router/linkage";
import { createRouter, createWebHistory } from "vue-router";

// リマコミ＋画面用ルート定義
const routes = createLinkageRoute(
    RIMACOMI_LINKAGE_ID,
    RIMACOMI_LINKAGE_NAME,
    RIMACOMI_PATH,
    RIMACOMI_SITE_UNIQ_API_PATH,
    RIMACOMI_DEFAULT_CALLBACK_URL,
    RIMACOMI_ACCEPT_CALLBACK_URLS,
    RIMACOMI_SERVICE_TERM_URL,
    RIMACOMI_EMAIL_DOMAINS,
    RIMACOMI_PROFILE_COMPONENT,
    RIMACOMI_CONFIRM_COMPONENT,
    {
        withDrawCustomComponent: RIMACOMI_WITHDRAW_CUSTOM_COMPONENT,
        profileCompleteCustomComponent: RIMACOMI_PROFILE_COMPLETE_CUSTOM_COMPONENT,
    }
);

// リマコミ＋画面用ルータ作成
const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    scrollBehavior: linkageScrollBehavior,
    routes: routes,
});

// beforeEach
router.beforeEach(linkageBeforeEach);

// リマコミ＋画面用ルータ
export const rimacomiRouter = router;
